import { createContext } from "react";

const CardStyleContext = createContext();

export default CardStyleContext;
